import React, { PropTypes } from 'react';
// import { Link } from 'react-router';
// Components
import MediaPartnersBox from './MediaPartnersBox';
import NoData from '../../layout/noData/NoData';
import LoadingContent from '../../layout/loadingContent/LoadingContent';
// Styles
import './mediaPartners.css';

const propTypes = {
  loading: PropTypes.bool,
  locale: PropTypes.string,
  id: PropTypes.string,
  medias: PropTypes.object,
};

const MediaPartnersList = (props) => {
  const medias = props.medias
    ? <MediaPartnersBox locale={props.locale} medias={props.medias} />
    : <NoData />;

  const result = props.loading
    ? <LoadingContent />
    : medias;

  // const link = `${props.locale}/media-partners/33`;

  return (
    <div style={{ textAlign: 'center' }}>
      {result}
    </div>
  );
};

MediaPartnersList.propTypes = propTypes;

export default MediaPartnersList;



/** WEBPACK FOOTER **
 ** ./src/components/screens/mediaPartners/MediaPartnersList.js
 **/